var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35354 5.16296C5.15828 4.9677 5.15828 4.65112 5.35354 4.45586L7.66295 2.14645C7.85821 1.95118 8.17479 1.95118 8.37006 2.14645L10.6795 4.45586C10.8747 4.65112 10.8747 4.9677 10.6795 5.16296C10.4842 5.35823 10.1676 5.35823 9.97236 5.16296L8.5 3.6906L8.5 10.5C8.5 10.7762 8.27614 11 8 11C7.72386 11 7.5 10.7762 7.5 10.5L7.5 3.72361L6.06065 5.16296C5.86538 5.35823 5.5488 5.35823 5.35354 5.16296ZM3 11.5V13.5C3 13.7762 3.22386 14 3.5 14H12.5C12.7761 14 13 13.7762 13 13.5V11.5C13 11.2239 12.7761 11 12.5 11C12.2239 11 12 11.2239 12 11.5V13H4V11.5C4 11.2239 3.77614 11 3.5 11C3.22386 11 3 11.2239 3 11.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.ac572454248aa3d48323891e2cec81e3.svg";
export { ForwardRef as ReactComponent };